import generateObjectId from '../../../utils/generateObjectId';
import { GROUP_KEY_PREFIX } from '../constants';
import { isChoiceAsk } from './blockBuilders';

export const createStepLinks = ({ createPath, updateBlockData, updateBlockDataJump }) => {
    const connectStepPaths = async (step, stepMap, groupsById = {}) => {
        const entry = stepMap[step.id];
        if (!entry) return;

        const connect = async (connectorObjectId, nextStepId) => {
            if (!connectorObjectId || !nextStepId) return;
            const target = stepMap[nextStepId];
            if (!target) return;
            await createPath(target.objectId, generateObjectId(), connectorObjectId);
        };

        switch (step.type) {
            case 'ask':
            case 'say': {
                if (isChoiceAsk(step)) {
                    for (const choice of step.choices) {
                        const child = entry.children.find(c => c.text === choice.label);
                        await connect(child?.object_id, choice.next);
                    }
                    break;
                }
                const connector = entry.children.find(c => c.text === 'Custom Response');
                await connect(connector?.object_id, step.next);
                break;
            }
            case 'announcement':
            case 'set_var':
            case 'api': {
                const connector = entry.children[0];
                await connect(connector?.object_id, step.next);
                break;
            }
            case 'condition': {
                const trueChild = entry.children.find(c => c.text === 'Vrai');
                const falseChild = entry.children.find(c => c.text === 'Faux');
                await connect(trueChild?.object_id, step.next_true);
                await connect(falseChild?.object_id, step.next_false);
                break;
            }
            case 'categorization': {
                for (let i = 0; i < step.branches.length; i++) {
                    const child = entry.children.find(c => c.text === 'Branch_' + i);
                    await connect(child?.object_id, step.branches[i].next);
                }
                const defaultChild = entry.children.find(c => c.text === 'Default');
                await connect(defaultChild?.object_id, step.default_next);
                break;
            }
            case 'jump': {
                if (step.target_group) {
                    const group = groupsById[step.target_group];
                    const header = stepMap[GROUP_KEY_PREFIX + step.target_group];
                    if (group && header) {
                        await updateBlockDataJump(entry.objectId, group.name, { object_id: header.objectId }, null, true, null);
                    }
                    break;
                }
                const target = stepMap[step.target];
                if (target) {
                    await updateBlockData(entry.objectId, { jump_id: null, is_constant: false, variable_value: target.objectId }, { is_constant: false, variable_value: target.objectId });
                }
                break;
            }
        }
    };

    return { connectStepPaths };
};
